import { useEffect, useState } from 'react';
import { supabase } from '../lib/webSite';

const BUCKET = 'testimonials';

function stars(rating) {
  const n = Math.max(1, Math.min(5, Number(rating) || 5));
  return '★'.repeat(n);
}

function normalizeQuote(quote) {
  return String(quote || '')
    .trim()
    .replace(/^["“]|["”]$/g, '');
}

function publicUrl(filePath) {
  if (!supabase || !filePath) return '';
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(filePath);
  return data?.publicUrl || '';
}

export default function useTestimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!supabase) return;
      try {
        const { data, error } = await supabase
          .from('testimonials')
          .select(
            'id, quote, author_name, author_title, rating, file_path, sort_order, is_active',
          )
          .eq('is_active', true)
          .order('sort_order', { ascending: true })
          .order('created_at', { ascending: true });

        if (error) throw error;
        if (cancelled) return;

        setItems(
          (data || [])
            .map((row) => {
              const rating = row.rating ?? 5;
              return {
                id: row.id,
                quote: normalizeQuote(row.quote),
                authorName: row.author_name,
                authorTitle: row.author_title || '',
                rating,
                stars: stars(rating),
                photoUrl: publicUrl(row.file_path),
              };
            })
            .filter((row) => row.quote && row.authorName),
        );
      } catch (err) {
        console.warn('Could not load testimonials.', err);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return items;
}
